// The image a Studio preview should load: the smallest server-generated
// variant at least minWidth pixels wide, or the original when no variant is
// wide enough (or the asset has none).
export function assetImageUrl(asset, minWidth) {
  const original = asset?.url
  if (asset?.asset_type && asset.asset_type !== 'image') return original
  const variants = Array.isArray(asset?.metadata?.variants) ? asset.metadata.variants : []
  const wideEnough = variants
    .filter((variant) => typeof variant?.url === 'string' && variant.url && Number(variant.width) >= minWidth)
    .sort((a, b) => Number(a.width) - Number(b.width))
  return wideEnough[0]?.url || original
}
